import { loadStripe } from '@stripe/stripe-js/pure'

const stripe = loadStripe(
  /*process.env.NODE_ENV === 'development'
    ? 'pk_test_51Md9GjK7kFPAGSrZDSKlhQ2cigWKfXsED6SDTeeOz58rifaAhusKa0NCM9jrewOP8WzC8IcDg3L8Tfg1YBVcCM0600z038boGr'
    :*/ 'pk_live_51Md9GjK7kFPAGSrZfLnihnOMB8gVuu5W0oas8AWOxXI0XfU8DlBu4QEdV3dNZju4xR7bUk8AgF8hQ4TZYiL8aQfb00fcUso1tS'
)

export default stripe
